import { html } from "lit";
import { t } from "../i18n/index.ts";
import type { AppViewState } from "./app-view-state.ts";
import "./components/file-manager-frame.ts";
import { normalizeBasePath, titleForTab } from "./navigation.ts";

/** HTTP path prefix of the file-manager plugin UI (default plugin id `file-manager`). */
export const FILE_MANAGER_PLUGIN_PATH = "/plugins/file-manager/";

export function gatewayWsUrlToHttpOrigin(wsUrl: string): string {
  const trimmed = wsUrl.trim();
  if (!trimmed) {
    return "";
  }
  try {
    const parsed = new URL(trimmed);
    const httpProto = parsed.protocol === "wss:" ? "https:" : "http:";
    return `${httpProto}//${parsed.host}`;
  } catch {
    return "";
  }
}

export function buildFileManagerEmbedUrl(params: {
  gatewayWsUrl: string;
  token: string;
  basePath: string;
}): string | null {
  const origin = gatewayWsUrlToHttpOrigin(params.gatewayWsUrl);
  if (!origin) {
    return null;
  }
  const base = normalizeBasePath(params.basePath);
  const path = `${base}/plugins/file-manager/`.replace(/\/{2,}/g, "/");
  let url: URL;
  try {
    url = new URL(path, `${origin}/`);
  } catch {
    return null;
  }
  const token = params.token.trim();
  if (token) {
    url.searchParams.set("token", token);
  }
  return url.toString();
}

export function renderFileManagerEmbed(state: AppViewState) {
  const wsUrl = state.settings.gatewayUrl?.trim() ?? "";
  const token = state.settings.token?.trim() ?? "";
  const url = buildFileManagerEmbedUrl({
    gatewayWsUrl: wsUrl,
    token,
    basePath: state.basePath ?? "",
  });

  if (!url) {
    return html`
      <div class="callout warn" style="margin-top: 12px;">${t("fileManager.missingGateway")}</div>
    `;
  }

  const title = titleForTab("fileManager");
  return html`
    <section class="file-manager-embed" aria-label=${title}>
      <openclaw-file-manager-frame
        .embedUrl=${url}
        .gatewayWsUrl=${wsUrl}
        .token=${token}
        .password=${state.password ?? ""}
        .themeMode=${state.themeMode}
        .theme=${state.theme}
      ></openclaw-file-manager-frame>
    </section>
  `;
}
